//Boilerplate
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { clone } from "lodash";
import CardContent from "@mui/material/CardContent";

//Our Stuff
import MacCard from "components/User/Mac/MacCard";
import { getPaySummary } from "actions/appraiser";

class AppraiserMacCard extends React.Component {
  constructor(props) {
    super(props);
    this.getPaySummary = this.getPaySummary.bind(this);
    this.getRows = this.getRows.bind(this);
    this.getFooterContent = this.getFooterContent.bind(this);
  }

  getRows(paySummary) {
    const {
      payPeriodCases,
      totalLateDeduction,
      totalReturnedDeduction,
      totalCostCurrent,
      totalCostPrevious,
      macBonusRemaining,
      macTotal,
      macBonus
    } = paySummary;
    let rows = clone(payPeriodCases);
    if (rows.length > 0) {
      rows.push({
        controlIdNumber: "Total",
        lateDeduction: totalLateDeduction,
        returnedDeduction: totalReturnedDeduction,
        costCurrent: totalCostCurrent,
        costPrevious: totalCostPrevious,
        macRemaining: macBonusRemaining,
        mac: macTotal,
        macBonus: macBonus
      });
    }
    return rows;
  }

  getPaySummary(appraiserNumber, payPeriodId) {
    const { getPaySummary } = this.props;
    getPaySummary(appraiserNumber, payPeriodId);
  }

  getFooterContent() {
    return (
      <CardContent className="md-divider-border md-divider-border--top">
        <p>
          The MAC, Cost, and Total values shown on this page are not the
          official record of your pay. All Mueller payroll information is found
          by logging into Mueller's Ultimate website and viewing your{" "}
          <a href="https://ew42.ultipro.com/Login.aspx" target="_new">
            pay statements
          </a>
          {"."}
        </p>
        <p>
          The information on this page reflects proprietary formulas and
          estimates used to determine if you are eligible for a discretionary
          bonus. This bonus is entirely discretionary and Mueller makes no
          guarantee of any minimum payments that will be owed resulting
          therefrom to any employee. We hope that this program will be
          beneficial to both you and the company, and we will evaluate it
          monthly to determine if that is the case. If it is not, we reserve the
          right to discontinue it.
        </p>
        <p>
          For further details regarding this program, please visit the{" "}
          <a
            href="../../IWAG/Training/2018_appraisal_mac/index.asp"
            target="_new"
          >
            Mueller training page
          </a>
          {"."}
        </p>
      </CardContent>
    );
  }

  render() {
    const {
      appraiserNumber,
      isFetchingAppraiserPayPeriodSummary,
      appraiserPayPeriodSummary,
      displayFooter
    } = this.props;
    return (
      <div className="appraiser-mac-card">
        <MacCard
          employeeID={appraiserNumber}
          getPaySummary={this.getPaySummary}
          isFetchingPayPeriodSummary={isFetchingAppraiserPayPeriodSummary}
          paySummary={appraiserPayPeriodSummary}
          getRows={this.getRows}
          footerContent={displayFooter ? this.getFooterContent : null}
          payPeriod={this.props.payPeriod}
          hidePayPeriodSelection={this.props.hidePayPeriodSelection}
          FRMac={false}
        />
      </div>
    );
  }
}

AppraiserMacCard.defaultProps = {
  displayFooter: false,
  hidePayPeriodSelection: false
};

AppraiserMacCard.propTypes = {
  //Pure Props
  appraiserNumber: PropTypes.number,
  displayFooter: PropTypes.bool,
  payPeriod: PropTypes.object,
  hidePayPeriodSelection: PropTypes.bool,

  //Redux Store State
  appraiserPayPeriodSummary: PropTypes.object,
  isFetchingAppraiserPayPeriodSummary: PropTypes.bool,

  //Redux Actions
  getPaySummary: PropTypes.func
};

const mapStateToProps = state => ({
  //Pay Period Sumary
  appraiserPayPeriodSummary: state.appraiser.payPeriodSummary,
  isFetchingAppraiserPayPeriodSummary: state.appraiser.fetchingPayPeriodSummary
});

const mapDispatchToProps = dispatch => ({
  getPaySummary(inspectorNumber, payPeriodId) {
    dispatch(getPaySummary(inspectorNumber, payPeriodId));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AppraiserMacCard);
